export const DAO_CODE = 'DEAL_ABANDONMENT_MOTIVES_DAO';
